export const ptBRCategories = {
  loading: 'Carregando categorias...',
  errorLoad: 'Falha ao carregar categorias. Tente novamente.',
  pageTitle: 'Categorias',
  addCategory: 'Adicionar Categoria',
  noCategories: 'Nenhuma categoria ainda. Crie sua primeira categoria.',
  modalCreateTitle: 'Criar Categoria',
  modalEditTitle: 'Editar Categoria',
  deleteTitle: 'Excluir Categoria',
  deleteMessage: 'Tem certeza que deseja excluir "{{name}}"? Esta acao nao pode ser desfeita.',
  deleteConfirm: 'Excluir',
  childCategoryLabel: '(sob {{name}})',
  formNameLabel: 'Nome',
  formNamePlaceholder: 'ex: Alimentacao',
  formColorLabel: 'Cor (opcional)',
  formColorPlaceholder: '#FF5733',
  formParentLabel: 'Categoria Pai (opcional)',
  formParentNone: 'Nenhuma (categoria principal)',
  formSaving: 'Salvando...',
  formCreating: 'Criando...',
  formSave: 'Salvar',
  formCreate: 'Criar',
  formError: 'Falha ao salvar categoria',
  validationNameRequired: 'Nome e obrigatorio',
  validationNameTooLong: 'Nome muito longo',
  validationColorInvalid: 'Cor deve ser um valor hexadecimal valido (ex: #FF5733)',
  noCategoriesTitle: 'Nenhuma categoria',
  noCategoriesMessage: 'Crie categorias para organizar suas despesas e contas.',
} as const;
